//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PurchasingSection',
  computed: {
    items() {
      return [
        {
          heading: this.$t('nav.pricing'),
          desc: this.$t(this.$wbr('user_guide.pricing_text')),
          to: this.$link('/pricing').fullPath(),
        },
        {
          heading: this.$t('term.payment_methods'),
          desc: this.$t(this.$wbr('user_guide.payment_methods_text')),
        },
        {
          heading: this.$t('user_guide.invoices_receipts_heading'),
          desc: this.$t(this.$wbr('user_guide.invoices_receipts_text')),
          href: this.$link('https://help.motionelements.com/docs/where-can-i-download-my-invoice-receipt').url(),
        },
      ];
    },
  },
};
